import * as angular from 'angular';
import { CargosService } from './cargos.service';

export const CargosModule = angular.module('CargosModule', ['ui.router.state'])
    .service('CargosService', CargosService)
    .name;
